/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./css-loader.component";
var styles_CssLoaderComponent = [];
var RenderType_CssLoaderComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_CssLoaderComponent, data: {} });
export { RenderType_CssLoaderComponent as RenderType_CssLoaderComponent };
export function View_CssLoaderComponent_0(_l) { return i0.ɵvid(0, [], null, null); }
export function View_CssLoaderComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "css-loader", [], null, null, null, View_CssLoaderComponent_0, RenderType_CssLoaderComponent)), i0.ɵdid(1, 114688, null, 0, i1.CssLoaderComponent, [i0.Renderer2, i0.ElementRef], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var CssLoaderComponentNgFactory = i0.ɵccf("css-loader", i1.CssLoaderComponent, View_CssLoaderComponent_Host_0, { src: "src" }, {}, []);
export { CssLoaderComponentNgFactory as CssLoaderComponentNgFactory };
